/* istanbul ignore file */
/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore ignores: An import path cannot end with a '.tsx' extension
import('./bootstrap.tsx');
